var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('figure',{staticClass:"is-3by2"},[_c('img',{staticStyle:{"object-fit":"cover"},attrs:{"src":_vm.staticMapURL}})])])}
var staticRenderFns = []

export { render, staticRenderFns }